






import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class WidgetGridContainer extends Vue {

  @Prop({ default: false })
  twoColumns: boolean;

  get containerClasses () {
    const results = {
      "widget-grid-container": true,
      "mx-0": true,
      "mx-md-3": true,
    };
    if (this.twoColumns) {
      results["widget-grid-container-2"] = true;
    } else {
      results["widget-grid-container-3"] = true;
    }
    return results;
  }
}
